import * as React from "react";
import { useNavigate } from "react-router-dom";
import './ExploreContent.css';

import img1 from '../Assets/livingroom.JPG';
import img2 from '../Assets/modern-kitchen-design-interior.jpg';
import img3 from '../Assets/modern-styled-small-entryway.jpg';
import img4 from '../Assets/bedroom.jpg';
import img5 from '../Assets/office.JPG';
import img6 from '../Assets/Children.JPG';
import img7 from '../Assets/HomeDecor.JPG';
import img8 from '../Assets/textile.JPG';
import img9 from '../Assets/accents.JPG';

export default function ExploreContent() {
  const navigate = useNavigate();

  const gridData = [
    { id: 1, imageUrl: img1, title: "Living Room", route: "/living-room" },
    { id: 2, imageUrl: img2, title: "Dining Room", route: "/dining-room" },
    { id: 3, imageUrl: img3, title: "Foyer / Entryways", route: "/foyer" },
    { id: 4, imageUrl: img4, title: "Bedroom", route: "/bedroom" },
    { id: 5, imageUrl: img5, title: "Office", route: "/office" },
    { id: 6, imageUrl: img6, title: "Children", route: "/children" },
    { id: 7, imageUrl: img7, title: "Home Decor", route: "/home-decor" },
    { id: 8, imageUrl: img8, title: "Textiles", route: "/textiles" },
    { id: 9, imageUrl: img9, title: "Accents", route: "/accents" },
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <div className="explore-wrapper">
      <div className="card-container">
        {gridData.map(item => (
          <div
            key={item.id}
            className="card"
            onClick={() => handleCardClick(item.route)}
            role="button"
            tabIndex="0"
            onKeyPress={(e) => e.key === "Enter" && handleCardClick(item.route)}
          >
            <img src={item.imageUrl} alt={item.title} className="card-image" />
            <div className="card-title-container">
      <div className="card-title">{item.title}</div>
      <div className="see-more">SEE MORE</div> {/* Add SEE MORE here */}
    </div>
          </div>
        ))}
      </div>
    </div>
  );
}
